import React from "react";
import { Link } from "react-router-dom";
import {motion} from "framer-motion";

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      delay:0.2,
      duration:0.5
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }

  }
}
export default function Home() {
  return (
    <motion.div className="container" exit={{x:"-100vw"}}
      variants={contVariant}
      initial="hidden"
      animate="visible"
    >
      <div className="home">
        <h1>Create your resume for free</h1>
        <p>we are here to help you building your fantastic resume</p>
        <Link to="/personal-info">
          <motion.button variants={linkVariant} whileHover="hover">Lets get started</motion.button>
        </Link>
      </div>
    </motion.div>
  );
}
